import React, { Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Col } from 'reactstrap';
import { Breadcrumbs, Spinner, H6 } from '../../../../AbstractElements';
import SchedulePost from '../../../../Component/Classes/Schedule/SchedulePost';
import { handleEditSchedule } from '../../../../Component/Classes/Schedule/ScheduleUtils';
import { setField, resetState } from '../../../../Features/Classes/Schedule/addScheduleSlice';
import { fetchSchedules } from '../../../../Features/Classes/Schedule/Utils/ScheduleUtils';


const ScheduleClassAdd = () => {
    const { scheduleId } = useParams();
    const addField = useSelector(state => state.addClass)
    const dispatch = useDispatch();
    const filters = useSelector(state => state.Schedule.filters)
    const isLoading = useSelector(state => state.Schedule.isLoading)

    useEffect(() => {
        if (!addField.id && scheduleId) {
            const newFilters = {
                ...filters,
                "filter[id]": scheduleId,
                "page": 1,
            };
            dispatch(fetchSchedules(newFilters))
                .then((response) => {
                    // Kode yang akan dijalankan setelah fetch sukses
                    handleEditSchedule(dispatch, response.payload.data[0], setField)
                    // Kode lain yang perlu dijalankan setelah fetch sukses
                })
                .catch((error) => {
                    // Tangani error jika fetch gagal
                    console.error('Error during fetchClasses:', error);
                });
        } else if (!scheduleId) {
            dispatch(resetState());
            // console.log(addField, "addField");
        }
    }, [scheduleId, addField.id, dispatch, filters]);

    return (
        <Fragment>
            <Breadcrumbs grandparent="Kelas" parent="Detail Kelas" title={scheduleId ? "Update Jadwal Sesi" : "Tambah Jadwal Sesi"} />
            {isLoading ? (
                <Col lg="12">
                    <div className="loader-box">
                        <Spinner attrSpinner={{ className: 'loader-30' }} />
                    </div>
                    <H6 attrH6={{ className: 'mb-0 text-center' }}>{'Data Loading...'}</H6>
                </Col>
            ) : (
            <SchedulePost />
            )}
        </Fragment>
    );
};
export default ScheduleClassAdd;